import { Collapse, Drawer } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../../../context/LoginContext";
import { useGetLineUrl } from "../../../../../hooks/LineLink/customerService.hooks";
import { useLogout } from "../../../../../hooks/UserCenter/usercenter.hooks";
import LeftArrow from "../../images/layout1/LeftArrow";
import ListIcon from "../../images/layout1/ListIcon";
import LogoutIcon from "../../images/layout1/LogoutIcon";
import RightArrow from "../../images/layout1/RightArrow";
import styles from "./style.module.scss";
import "./style.scss";

const DrawerMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { mutate: logout } = useLogout();
  const { isLogin } = useLogin();
  const { data: customerService } = useGetLineUrl({});
  const { Panel } = Collapse;

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    setOpen(false);
    logout();
    setTimeout(() => {
      navigate("/signin");
    }, 1000);
  };

  const handleLogin = async () => {
    setOpen(false);
    setTimeout(() => {
      navigate("/signin");
    }, 1000);
  };

  const menuList = [
    {
      label: t("header.esim.guide"),
      path: "/installguide",
      key: "guide",
    },
    {
      label: t("normal.brand.introduction"),
      path: "/brand",
      key: "intro",
      hide: process.env.REACT_APP_HIDE_BRAND_STORY,
    },
    {
      label: t("normal.common.issue"),
      path: "/commonissue",
      key: "commonIssue",
    },
    {
      label: t("normal.termsOfService"),
      path: "/terms",
      key: "terms",
    },
    {
      label: t("normal.privacyPolicy"),
      path: "/privacypolicy",
      key: "privacy",
    },
    {
      label: t("normal.returnExchange"),
      path: "/returnandexchange",
      key: "return",
      hide: process.env.REACT_APP_HIDE_RETURN_POLICY,
    },
    {
      label: t("menuItem.contactCs"),
      key: "contactCs",
      children: (
        <div className={styles.media}>
          <div>{t("footer.csServiceHour.mobile")}</div>
          <div>
            {t("normal.officialCs")}
            <a href="https://lin.ee/Y9vFE3BI">{t("menuItem.goNow")}</a>
          </div>
        </div>
      ),
    },
    {
      label: t("menuItem.followUs"),
      key: "contactCs",
      children: (
        <div style={{ lineHeight: 2 }}>
          <div
            className={styles.media}
            onClick={() => {
              getSocialMediaUrl("faceboock_link");
            }}
          >
            Facebook
          </div>
          <div
            className={styles.media}
            onClick={() => {
              getSocialMediaUrl("twitter_link");
            }}
          >
            X.com
          </div>
          <div
            className={styles.media}
            onClick={() => {
              getSocialMediaUrl("linkedin_link");
            }}
          >
            LinkedIn
          </div>
          <div
            className={styles.media}
            onClick={() => {
              getSocialMediaUrl("instagram_link");
            }}
          >
            Instagram
          </div>
        </div>
      ),
    },
  ];

  const MenuItem = ({ label, path }: { label: string; path: string }) => (
    <div
      className={styles.menuItem}
      onClick={() => {
        if (!path) return;
        navigate(path, { replace: true });
        onClose();
      }}
    >
      <div className={styles.label}>{label}</div>
      <RightArrow />
    </div>
  );

  const getSocialMediaUrl = (name: any) => {
    const url = customerService?.filter((u: any) => u.name === name);
    if (url) {
      window.open(url[0]?.value);
    }
  };

  return (
    <>
      <div className={`${styles.drawerMenu} drawer-menu-container`}>
        <div className={styles.icon} onClick={showDrawer}>
          <ListIcon />
        </div>
        <Drawer
          width={"100vw"}
          placement={"left"}
          onClose={onClose}
          open={open}
          closeIcon={<LeftArrow />}
          styles={{
            header: { borderBottom: "none", padding: "15px 16px" },
            body: { padding: "0 0 70px" },
          }}
        >
          {menuList
            .filter((_menu) => _menu.hide !== "true")
            .map((menu) => {
              if (menu.children) {
                return (
                  <Collapse
                    ghost
                    key={menu.key}
                    className={styles.collapse}
                    expandIconPosition="end"
                    expandIcon={({ isActive }) => (
                      <RightArrow
                        style={{ transform: isActive ? "rotate(90deg)" : "" }}
                      />
                    )}
                  >
                    <Panel header={menu.label} key={menu.key}>
                      {menu.children}
                    </Panel>
                  </Collapse>
                );
              } else {
                return (
                  <MenuItem
                    label={menu.label}
                    path={menu.path}
                    key={menu.key}
                  />
                );
              }
            })}

          {isLogin ? (
            <div className={styles.logoutSection}>
              <div className={styles.logoutItems} onClick={handleLogout}>
                <div>{t("normal.logout")}</div>
                <LogoutIcon />
              </div>
            </div>
          ) : (
            <div className={styles.loginSection}>
              <div className={styles.loginItems} onClick={handleLogin}>
                <div>{t("normal.siginin")}</div>
                <LogoutIcon color="var(--grey900)" />
              </div>
            </div>
          )}
        </Drawer>
      </div>
    </>
  );
};

export default DrawerMenu;
